/**
 * Preview of functions/emailTemplates.js clientCampaignEmailTemplate
 * (must stay visually aligned with the server wrapper).
 */
const FIDDUX_LOGO_URL =
  "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/Logo-grey%2FFIDDUX.png?alt=media&token=100dec8d-bdac-43d3-8b41-3087a817b398";

export function buildClientEmailPreviewHtml(contentHtml, options = {}) {
  const eyebrow = options.eyebrow || "CLIENT UPDATE";
  const inner = contentHtml || "";
  return `<!DOCTYPE html>
<html><head><meta charset="UTF-8"/><meta name="viewport" content="width=device-width, initial-scale=1.0"/><title>Fiddux</title></head>
<body style="margin:0;padding:0;background-color:#F8FAFC;font-family:Georgia,'Times New Roman',serif;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#F8FAFC;padding:32px 12px;">
<tr><td align="center">
<table role="presentation" width="600" cellpadding="0" cellspacing="0" border="0" style="max-width:600px;width:100%;background-color:#ffffff;border-radius:2px;overflow:hidden;">
<tr><td style="height:4px;line-height:4px;font-size:0;background-color:#2AF598;">&nbsp;</td></tr>
<tr><td style="padding:36px 40px 20px 40px;background-color:#ffffff;">
<a href="https://www.fiddux.com/" target="_blank" style="text-decoration:none;">
<img src="${FIDDUX_LOGO_URL}" alt="Fiddux" width="140" style="display:block;max-width:140px;height:auto;border:0;" />
</a>
<p style="margin:22px 0 0 0;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:11px;letter-spacing:2.5px;color:#009658;font-weight:bold;text-transform:uppercase;">${eyebrow}</p>
</td></tr>
<tr><td style="padding:0;background-color:#ffffff;">${inner}</td></tr>
<tr><td style="padding:8px 40px 36px 40px;background-color:#ffffff;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-top:1px solid #e5e5e5;padding-top:24px;">
<tr><td style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:22px;padding-bottom:10px;">
<span style="color:#009658;font-weight:bold;font-size:15px;letter-spacing:2px;">INFO&nbsp;</span>
<span style="letter-spacing:2px;color:#AAAAAA;">| FIDDUX TEAM</span>
</td></tr>
<tr><td style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:20px;color:#AAAAAA;">Head Office:&nbsp;<a href="tel:+37258537809" style="color:#009658;text-decoration:none;">+37258537809</a></td></tr>
<tr><td style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:20px;color:#AAAAAA;">Jõe 2a, 10151 Tallinn, Estonia</td></tr>
<tr><td style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:20px;padding-top:4px;"><a href="https://www.fiddux.com/" target="_blank" style="color:#009658;text-decoration:none;font-weight:bold;letter-spacing:2px;">FIDDUX.COM</a></td></tr>
</table>
</td></tr>
<tr><td style="padding:18px 40px;background-color:#F8FAFC;border-top:1px solid #e8ebe8;">
<p style="margin:0;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:11px;line-height:1.5;color:#AAAAAA;text-align:center;">Private wealth communications · Fiddux · Tallinn, Estonia</p>
</td></tr>
</table>
</td></tr></table>
</body></html>`;
}
